export default "__VITE_ASSET__BptNAgz0__"